<template>
    <div class="min-max-controls">
        <div class="d-flex align-items-center">
            <label 
                v-if="!hideMin"
                class="rwfc"
                :class="minWrapperClass">
                <span :for="minElId" class="sr-only">{{ minLabel }}</span>
                <span class="addon-grp">
                    <template v-if="minSymbolBefore"><span class="item">{{ minSymbolBefore }}</span></template>
                    <input 
                        :id="minElId" 
                        class="rwfc__input"
                        v-model="minValue"
                        placeholder="Min"
                        @blur="onBlur('min', $event.target.value)"
                        :aria-label="minLabel">
                    <template v-if="minSymbolAfter"><span class="item">{{ minSymbolAfter }}</span></template>
                </span>
            </label>
            <span v-if="!hideMax && !hideMin" class="divider-text">-</span>
            <label 
                v-if="!hideMax"
                class="rwfc"
                :class="maxWrapperClass">
                <span :for="maxElId" class="sr-only">{{ maxLabel }}</span>
                <span class="addon-grp">
                    <template v-if="maxSymbolBefore"><span class="item">{{ maxSymbolBefore }}</span></template>
                    <input 
                        :id="maxElId" 
                        class="rwfc__input"
                        v-model="maxValue"
                        placeholder="Max"
                        @blur="onBlur('max', $event.target.value)"
                        :aria-label="maxLabel">
                    <template v-if="maxSymbolAfter"><span class="item">{{ maxSymbolAfter }}</span></template>
                </span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        minLabel: {
            type: String,
            default: 'Minimum Value'
        },
        maxLabel: {
            type: String,
            default: 'Maximum Value'
        },
        minElId: {
            type: String,
            default: 'rw-min-max-control-input--min'
        },
        maxElId: {
            type: String,
            default: 'rw-min-max-control-input--max'
        },
        minWrapperClass: {
            type: String,
            default: ''
        },
        maxWrapperClass: {
            type: String,
            default: ''
        },
        minSymbolBefore: { type: String },
        maxSymbolBefore: { type: String },
        minSymbolAfter: { type: String },
        maxSymbolAfter: { type: String },
        minVal: { },
        maxVal: { },
        hideMin: {
            type: Boolean,
            default: false
        },
        hideMax: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        onChange: _.debounce(function(type, value){
            if(isNaN(value)) value = '';
            this.$emit(`${type}-value-changed`, value);
        }, 300),
        onBlur(type, value){
            this.$emit(`${type}-value-changed`, value);
        }
    },
    computed: {
        minValue: {
            get(){
                return this.minVal;
            },
            set(value){
                // this.onChange('min', value);
            }
        },
        maxValue: {
            get(){
                return this.maxVal;
            },
            set(value){
                // this.onChange('max', value);
            }
        }
    }

}
</script>

<style>

</style>
